import React, { useState, useEffect } from "react";
import Styles from "./style.module.css";
import { FiPlusSquare } from "react-icons/fi";
import { useNavigate } from "react-router";
import { BasicInfo_DependentInfo_get } from "Services/Requests";
import { showWarningAlert } from "Utils/Alerts";
import Load from "Components/Loader/loader";
import { useStore } from "Store";
import DatePicker from "react-datepicker";
import Moment from "react-moment";
function DependantInfo() {
    const navigate = useNavigate();
    const { isDisabled } = useStore((state: any) => state);

    const [loading, setLoading] = useState(true);
    const [DependantInfo, setDependantInfo] = useState([]);
    const GetDetails = async () => {
        setLoading(true);
        try {
            const response = await BasicInfo_DependentInfo_get();
            setTimeout(() => {
                setLoading(false);
            }, 300);
            if (response?.data.status === 1) {
                if (
                    response.data?.dependent_info &&
                    response.data?.dependent_info?.length > 0
                ) {
                    setDependantInfo(
                        response.data?.dependent_info?.filter(
                            (item: any) => item.status != 0
                        )
                    );
                }
            }
        } catch (err: any) {
            console.log(err);
            showWarningAlert(
                "Something went wrong try again,if Issue persists Contact Support team"
            );
            setLoading(false);
        }
    };
    useEffect(() => {
        GetDetails();
    }, []);
    console.log(DependantInfo);
    return (
        <div className={Styles["Container"]}>
            {loading && <Load />}
            <div className={Styles["depedent-wrapper"]}>
                <header>
                    <h3>Dependent Info</h3>
                    {!isDisabled && (
                        <button
                            onClick={() =>
                                navigate("/auth/basic-info/dependent-info/add")
                            }>
                            <FiPlusSquare />
                            Add Dependent
                        </button>
                    )}
                </header>
                <div className={Styles["table-wrapper"]}>
                    <table className={Styles["tax-years"]}>
                        <thead className={Styles["tax-heading"]}>
                            <tr>
                                <th>First Name</th>
                                <th>Last Name</th>
                                <th>DOB</th>
                                <th>Relationship</th>
                                <th>Visa Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {DependantInfo.length > 0 ? (
                                DependantInfo.map((item: any) => (
                                    <tr
                                        onClick={() =>
                                            navigate(
                                                `/auth/basic-info/dependent-info/add?id=${item?.id}`
                                            )
                                        }>
                                        <td>{item?.first_name} </td>
                                        <td>{item?.last_name}</td>
                                        <td>
                                            {item?.dob && (
                                                <Moment format="MM-DD-YYYY">
                                                    {item?.dob}
                                                </Moment>
                                            )}
                                        </td>
                                        <td>{item?.relationship}</td>
                                        <td>{item?.visa_status}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={5}> No Record Found</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default DependantInfo;
